export const getClassName = isLeftSectionCollapsed => {
  return "AlertBox" + (isLeftSectionCollapsed ? "--hidden-section" : "");
};
